var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrain = function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160-340v-380q0-53 27.5-84.5t72.5-48 102.5-22T480-880q66 0 124.5 5.5t102 22 68.5 48 25 84.5v380q0 59-40.5 99.5T660-200l60 60v20h-80l-80-80H400l-80 80h-80v-20l60-60q-59 0-99.5-40.5T160-340m320-460q-106 0-155 12.5T258-760h448q-15-17-64.5-28.5T480-800M240-560h200v-120H240zm420 80H240h480zm-140-80h200v-120H520zM340-320q26 0 43-17t17-43-17-43-43-17-43 17-17 43 17 43 43 17m280 0q26 0 43-17t17-43-17-43-43-17-43 17-17 43 17 43 43 17m-320 40h360q26 0 43-17t17-43v-140H240v140q0 26 17 43t43 17m180-480h226-448z"
  })));
};
export default SvgTrain;